export const FILE_NAME_MIN_LENGTH = 1;
export const FILE_NAME_MAX_LENGTH = 60;
